import { Chip } from "components";
import { AppointmentStatus } from "types";
import { capitalize } from "helpers";
import { STATUS_COLORS } from "./constants";

interface StatusChipProps {
  status: AppointmentStatus;
}

const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  return <Chip {...STATUS_COLORS[status]}>{capitalize(status)}</Chip>;
};

export default StatusChip;
